import { createTheme} from '@mui/material/styles';

const theme = createTheme({
    palette: {
    neutral: {
        main: '#212B36',
        contrastText: '#fff',
    },
    },
}); 

export default function Theme() {
    return(
        theme
    )
}